module.exports = __webpack_public_path__ + "img/W7015-trad.54e9bc9b.jpg";